/** Format one ISO date without changing its stored verification date. */
export function contentDate(value: string, locale: string) {
  const date = new Date(value + 'T00:00:00Z');
  const formatted = new Intl.DateTimeFormat(
    locale === 'zh' ? 'zh-CN' : 'en-US',
    {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC',
    }
  ).format(date);
  return locale === 'zh'
    ? formatted.replace('年', ' 年 ').replace('月', ' 月 ').replace('日', ' 日')
    : formatted;
}
